// How a task's deadline reads: "Oct 18, 2026" and a short badge ("3d overdue", "Today", "2 days left").
// Shared by Goals, Tasks, Today and the add-task sheet.
import { C } from "./theme";
import { daysUntil, parseKey } from "./dates";

// Every date the app writes out is month first, in en-US, with the year only when it isn't this year.
const formatKey = (dateStr, opts) => {
  const d = parseKey(dateStr);
  return d.toLocaleDateString("en-US", { ...opts, ...(d.getFullYear() === new Date().getFullYear() ? {} : { year: "numeric" }) });
};
// "Saturday, November 14"
export const longDate = (dateStr) => formatKey(dateStr, { weekday: "long", month: "long", day: "numeric" });
// "Dec 19"
export const monthDay = (dateStr) => formatKey(dateStr, { month: "short", day: "numeric" });
// "November 14"
export const shortDate = (dateStr) => formatKey(dateStr, { month: "long", day: "numeric" });

export const formatDeadlineDate = (dateStr) => {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const deadlineBadge = (dateStr, baseColor) => {
  const days = daysUntil(dateStr);
  if (days === null) return null;
  const color = days < 0 ? C.red : baseColor;
  const label = days < 0
    ? `${Math.abs(days)}d overdue`
    : days === 0 ? "Today"
    : days === 1 ? "1 day left"
    : `${days} days left`;
  return { label, color };
};

// A deadline in words, the way the add-task sheet says it: "2 days overdue", "Due today",
// "Due in 3 days · Oct 21". The year shows only when it isn't this year.
export const dueWords = (dateStr) => {
  const days = daysUntil(dateStr);
  if (days === null) return null;
  const n = Math.abs(days), unit = n === 1 ? "day" : "days";
  if (days < 0) return { text: `${n} ${unit} overdue`, overdue: true };
  if (days === 0) return { text: "Due today", overdue: false };
  return { text: `Due in ${n} ${unit} · ${monthDay(dateStr)}`, overdue: false };
};
